module.exports = __webpack_public_path__ + "static/media/bags-shopping.3a8f539f.svg";